import {
    Avatar,
    Image
} from '@mantine/core';

import {AiOutlineUnorderedList} from 'react-icons/ai';
import {Organization} from '../types';

export const RecordLogo = ({
                               record,
                               size = '70',
                           }: {
    record: Organization,
    size?: string
}) => {
    const alt = record.name;

    if (record.logoUrl) {
        return <Image src={record.logoUrl}/>
    }

    return (
        <Avatar alt={alt} size={size}>
            <AiOutlineUnorderedList/>
        </Avatar>
    );
};
